export const getUser = ({ user }) => user.data;
export const getIsUserSubscribed = ({ user }) => user.data?.isValidSub;
export const getSubscriptionStatuses = ({ user }) => [user.data?.subscription_status, user.data?.subscription_status_android];
export const getUserLoading = ({ user }) => user.loading;
export const getUserError = ({ user }) => user.error;
